import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { SelectInputData } from '../../../interfaces/select-input-data.interface';
import { LocLabel } from '../../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss']
})
export class RadioInputComponent<T> implements ControlValueAccessor {
  @Input() public labelKey: string | LocLabel | null | undefined;
  @Input() disabled = false;
  @Input() oneLine = true;
  @Input() padding = true;
  @Input() options!: SelectInputData<T>[];

  private _value: any;
  // TODO: Why ngModel on this component doesn't work???
  constructor(public ngControl: NgControl, public rwdService: RWDService) {
    ngControl.valueAccessor = this;
  }

  // this method sets the value programmatically
  // tslint:disable-next-line:typedef
  public writeValue(value: any) {
    if (value !== this._value) {
      this._value = value;
    }
  }

  get value(): any {
    return this._value;
  }
  set value(value: any) {
    this.writeValue(value);
    this.onChange(value);
    this.onTouch(value);
  }

  // upon UI element value changes, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // upon touching the element, this method gets triggered
  // tslint:disable-next-line:typedef
  public registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  public onChange: any = (value: any) => {
    this.value = value;
  };
  public onTouch: any = () => {};
}
